import React, { useEffect, useRef } from "react";

// Renders a 360° experience: Matterport/Kuula iframe if tour_url is set,
// otherwise a built-in Pannellum equirectangular viewer for panorama_url.
const PanoramaViewer = ({ tourUrl, panoramaUrl }) => {
  const ref = useRef(null);
  const viewerRef = useRef(null);

  useEffect(() => {
    if (tourUrl || !panoramaUrl) return;
    if (!window.pannellum || !ref.current) return;
    viewerRef.current = window.pannellum.viewer(ref.current, {
      type: "equirectangular",
      panorama: panoramaUrl,
      autoLoad: true,
      autoRotate: -2,
      showControls: true,
      compass: false,
    });
    return () => {
      try { viewerRef.current?.destroy(); } catch {}
    };
  }, [tourUrl, panoramaUrl]);

  if (tourUrl) {
    return (
      <div data-testid="tour-iframe" className="w-full h-[460px] overflow-hidden rounded-2xl border border-navy/10">
        <iframe title="Visite virtuelle 360°" src={tourUrl} className="w-full h-full" allowFullScreen allow="xr-spatial-tracking; gyroscope; accelerometer" />
      </div>
    );
  }

  if (!panoramaUrl) {
    return <div className="text-muted-foreground text-sm">Visite 360° bientôt disponible.</div>;
  }

  return <div data-testid="panorama-viewer" ref={ref} className="w-full h-[460px] overflow-hidden rounded-2xl border border-navy/10 bg-navy" />;
};

export default PanoramaViewer;
